import Sticky from 'sticky-js'
import 'waypoints/lib/noframework.waypoints.min.js';
import './components/parallax'
import * as basicLightbox from 'basiclightbox'

const titles = document.querySelectorAll('.text-section__copy h2:first-child')
const highlights = document.querySelectorAll('.highlight')
const stats = document.querySelectorAll('.text-section__stat')

titles.forEach(el => {
  new Waypoint({
    element: el,
    handler: () => {
      el.classList.add('active')
    },
    offset: '90%'
  })
})

highlights.forEach(el => {
  new Waypoint({
    element: el,
    handler: () => {
      el.classList.add('active')
    },
    offset: '50%'
  })
})

stats.forEach(el => {
  new Waypoint({
    element: el,
    handler: () => {
      el.classList.add('active')
    },
    offset: '45%'
  })
})

new Sticky('.sticky')

const videoBtn = document.getElementById('videoBtn')
const vidId = videoBtn.dataset.videoId
const instance = basicLightbox.create(`
  <iframe width="560" height="315" class="video__video" src="https://www.youtube.com/embed/${vidId}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
`)

videoBtn.addEventListener('click', instance.show)